import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import React from 'react'
import { connect } from 'react-redux'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import InfoPanel from '../../components/InfoPanel'
import {
  formulySkonsolidowaneZestawienieZmianWKapitale,
  formulyZestawienieZmianWKapitale,
  formulyZZwKDomMaklerski,
} from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach, dajStrukture } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import RachunekPrzeplywowStyle from '../../styles/RachunekPrzeplywowStyle'
import ImportCSVInfo from '../../components/Zestawienie/ImportCSVInfo'

export class ZestawienieZmianWKapitale extends React.Component {
  isValueInThirdColumn = () => {
    return this.props.section.Dane.Pozycje.some(i => i.KwotaB1 !== 0)
  }
  state = {
    isThirdColumn: this.isValueInThirdColumn(),
    stopUpdate: false,
  }
  handleChange = (value, index, name) => {
    if (this.state.stopUpdate) return
    console.log('change')

    if (!value && name !== 'Nazwa') value = 0
    this.props.onSetSectionDataArray(value, index, name)

    this.aktualizujSumy(value, index, name)
  }

  aktualizujSumy = (value, index, name) => {
    if (this.props.czyWylaczoneFormulyZZwK) return
    if (name === 'Nazwa') return
    if (this.props.section.Dane.Pozycje[index].NrObliczeniowy === -1) return

    const formuly = this.dajFormuly()
    formuly.forEach(x => {
      let suma = this.sumValues(value, index, name, x.polaSkladowe)
      if (!x.warunek)
        this.props.onSetSectionDataArray(suma, this.getIndex(x.poleSumy), name)
      else if (x.warunek) {
        if (x.warunek(suma))
          this.props.onSetSectionDataArray(
            suma,
            this.getIndex(x.poleSumy),
            name,
          )
        else
          this.props.onSetSectionDataArray(
            this.sumValues(
              value,
              index,
              name,
              x.polaSkladoweBis ? x.polaSkladoweBis : [],
            ),
            this.getIndex(x.poleSumy),
            name,
          )
      }
    })
  }

  dajFormuly = () => {
    switch (this.props.struktura) {
      case 'Inna':
      case 'Mikro':
      case 'Mala':
      case 'OP':
        return formulyZestawienieZmianWKapitale
      case 'DomMaklerski':
        return formulyZZwKDomMaklerski
      case 'SkonsolidowanaInna':
        return formulySkonsolidowaneZestawienieZmianWKapitale
      default:
        return null
    }
  }

  sumValues = (value, changedIndex, name, parts) => {
    let partsSum = 0
    let partsSecondLevel = []
    let partsThirdLevel = []

    parts.forEach(x => {
      if (x.warunek) {
        if (
          x.warunek(this.sumValues(value, changedIndex, name, x.polaSkladowe))
        ) {
          partsThirdLevel = this.getSubFields(
            value,
            changedIndex,
            name,
            x.polaSkladowe,
          )
          partsSecondLevel = [...partsSecondLevel, ...partsThirdLevel]
        } else {
          partsThirdLevel = this.getSubFields(
            value,
            changedIndex,
            name,
            x.polaSkladoweBis,
          )
          partsSecondLevel = [...partsSecondLevel, ...partsThirdLevel]
        }
      }
    })
    parts = [...parts, ...partsSecondLevel]
    parts.forEach(x => {
      if (x.warunek) return
      if (x < 0) {
        let i = Math.abs(x)
        partsSum = zaokragl(
          partsSum -
            (this.getIndex(i) === changedIndex
              ? value
              : this.getValue(i, name)),
        )
      } else
        partsSum = zaokragl(
          partsSum +
            (this.getIndex(x) === changedIndex
              ? value
              : this.getValue(x, name)),
        )
    })
    return partsSum
  }

  getIndex = NrObliczeniowy => {
    let pozycja = this.getPozycjaByNrObliczeniowy(NrObliczeniowy)
    return this.props.section.Dane.Pozycje.indexOf(pozycja)
  }

  getValue = (index, name) => {
    let pozycja = this.getPozycjaByNrObliczeniowy(index)
    return pozycja[name]
  }

  getPozycjaByNrObliczeniowy = NrObliczeniowy => {
    return this.props.section.Dane.Pozycje.find(
      p => p.NrObliczeniowy === NrObliczeniowy,
    )
  }

  getSubFields = (value, changedIndex, name, pola) => {
    let result = []
    pola.forEach(y => {
      if (y.warunek) {
        if (
          y.warunek(this.sumValues(value, changedIndex, name, y.polaSkladowe))
        )
          result = [...result, ...y.polaSkladowe]
        else result = [...result, ...y.polaSkladoweBis]
      }
    })
    return [...result, ...pola]
  }

  handleCheckbox = value => {
    this.props.onSetSectionData('CzyJestZestawienie', value, 0)
  }

  setIsThirdColumn = v => {
    this.setState({ isThirdColumn: v })
  }

  wyczyscKwoty = async () => {
    this.setState({ stopUpdate: true })
    await this.props.onClearTable('Pozycje')
    this.setState({ stopUpdate: false })
  }

  dodajPozycjeUszczegolawiajaca = async (index, sciezka, poziom) => {
    const pozycje = [...this.props.section.Dane.Pozycje]
    let nowaPozycja = {
      Nr: 0,
      NrObliczeniowy: -1,
      Poziom: poziom,
      Nazwa: null,
      Edytowalny: true,
      Sciezka: sciezka,
      KwotaA: 0.0,
      KwotaB: 0.0,
      KwotaB1: 0.0,
      Uszczegolowienie: { Sciezka: sciezka, Poziom: poziom, CzyDziecko: false },
    }
    pozycje.splice(index + 1, 0, nowaPozycja)
    this.setState({ stopUpdate: true })
    await this.props.onSetSectionData('Pozycje', pozycje, 0)
    this.setState({ stopUpdate: false })
  }

  usunPozycjeUszczegolawiajaca = async index => {
    const pozycje = [...this.props.section.Dane.Pozycje]
    pozycje.splice(index, 1)
    this.setState({ stopUpdate: true })
    await this.props.onSetSectionData('Pozycje', pozycje, 0)
    this.setState({ stopUpdate: false })
  }

  render() {
    const {
      onImportCSV,
      onSetCzyWylaczoneFormulyZZwK,
      id,
      struktura,
      section,
      czyKwotyWTysiacach,
      czyWylaczoneFormulyZZwK,
    } = this.props
    return (
      <>
        <InfoPanel rolledContent={ImportCSVInfo} />
        {section.Dane.CzyJestZestawienie && czyWylaczoneFormulyZZwK && (
          <InfoPanel
            warningIcon
            warningColor
            rolledContent={
              <div>
                Formuły obliczeniowe w zestawieniu zostały tymczasowo wyłączone.
                Oznacza to, że wszystkie pozycje możesz wypełnić ręcznie.
                <br />
                Opcja wyłączenia formuł nie jest zapisywana w pliku. Jeśli
                ponownie otworzysz plik, pamiętaj, by na nowo wyłączyć formuły.
              </div>
            }
          />
        )}
        <RachunekPrzeplywowStyle
          className={!section.Dane.CzyJestZestawienie ? 'hide-on-print' : ''}
        >
          <ZestawienieName
            name="ZESTAWIENIE ZMIAN W KAPITALE"
            onImport={file => onImportCSV(id, section, file)}
            onClear={this.wyczyscKwoty}
            hideButtons={!section.Dane.CzyJestZestawienie}
          />
          {struktura !== 'DomMaklerski' && (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={section.Dane.CzyJestZestawienie}
                  onChange={e => this.handleCheckbox(e.target.checked)}
                />
              }
              label="Dołącz zestawienie zmian w kapitale"
            />
          )}
          <div className="container">
            {section.Dane.CzyJestZestawienie && (
              <>
                <FormControlLabel
                  className="additional-checkbox"
                  control={
                    <Checkbox
                      color="primary"
                      checked={czyWylaczoneFormulyZZwK}
                      onChange={e =>
                        onSetCzyWylaczoneFormulyZZwK(e.target.checked)
                      }
                    />
                  }
                  label="Wyłącz formuły obliczeniowe"
                />
                <ZestawienieHeader
                  isThirdColumn={this.state.isThirdColumn}
                  onCheck={e => this.setIsThirdColumn(e.target.checked)}
                />
                <div className="list">
                  <Zestawienie
                    dane={section.Dane.Pozycje}
                    onSetSectionDataArray={this.handleChange}
                    czyKwotyWTysiacach={czyKwotyWTysiacach}
                    isThirdColumn={this.state.isThirdColumn}
                    czyWylaczoneFormuly={czyWylaczoneFormulyZZwK}
                    dodajPozycjeUszczegolawiajaca={
                      this.dodajPozycjeUszczegolawiajaca
                    }
                    usunPozycjeUszczegolawiajaca={
                      this.usunPozycjeUszczegolawiajaca
                    }
                  />
                </div>
              </>
            )}
          </div>
        </RachunekPrzeplywowStyle>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
    struktura: dajStrukture(state.sprawozdanie.header),
    id: state.sprawozdanie.header.Id,
    czyWylaczoneFormulyZZwK: state.sprawozdanie.czyWylaczoneFormulyZZwK,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onSetSectionData: (name, value, index) => {
      dispatch(actions.setSectionData(name, value, index))
    },
    onSetSectionDataArray: (value, index, name) => {
      dispatch(actions.setSectionDataArray(value, index, 0, name))
    },
    onImportCSV: (id, section, file) => {
      dispatch(actions.importCSV(id, section, file))
    },
    onClearTable: array => dispatch(actions.clearTable(array)),
    onSetCzyWylaczoneFormulyZZwK: value =>
      dispatch(actions.setCzyWylaczoneFormulyZZwK(value)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ZestawienieZmianWKapitale)
